import { gql } from '@apollo/client';
import { SearchFilter } from 'types/Filters';

const listDatasetStorageLocations = (
    datasetUri: string,
    filter: SearchFilter,
) => {
    return {
        variables: {
            datasetUri,
            filter,
        },
        query: gql`
            query GetDataset(
                $datasetUri: String!
                $filter: DatasetStorageLocationFilter
            ) {
                getDataset(datasetUri: $datasetUri) {
                    AwsAccountId
                    region
                    targetS3BucketName
                    locations(filter: $filter) {
                        count
                        page
                        pages
                        nodes {
                            locationUri
                            created
                            S3Prefix
                            AwsAccountId
                            label
                        }
                    }
                }
            }
        `,
    };
};

export default listDatasetStorageLocations;
